import { useEffect, useState } from 'react';
import { API_URL, apiFetch, authHeaders } from '../../store';
import { buildNovaBracket } from '../mlbb/novaBracketEngine';

export function drawGroups(names, random = Math.random) {
  const shuffled = [...names];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  const groups = Array.from({ length: 4 }, (_, index) => ({ id: String(index + 1), teams: [] }));
  shuffled.forEach((name, index) => groups[index % 4].teams.push(name));
  buildNovaBracket(groups);
  return groups;
}

export default function GroupDraw({ tourId, game, groups, onDraw }) {
  const [teams, setTeams] = useState([]);
  const [selected, setSelected] = useState([]);
  const [allTeams, setAllTeams] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [reload, setReload] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');
    const params = new URLSearchParams({ tour: tourId, game });
    (async () => {
      try {
        const response = await apiFetch(`${API_URL}/fed-teams/state?${params}`, { headers: authHeaders(false) });
        const data = await response.json();
        if (!response.ok) throw new Error('Не удалось загрузить команды');
        const registered = new Set((data.regs || []).filter((reg) => reg.tourId === tourId).map((reg) => reg.teamId));
        const rows = (data.teams || []).map((team) => ({ ...team, registered: registered.has(team.id) }));
        if (active) {
          setTeams(rows);
          setSelected((previous) => previous.filter((id) => rows.some((team) => team.id === id)));
        }
      } catch (err) { if (active) setError(err.message); }
      finally { if (active) setLoading(false); }
    })();
    return () => { active = false; };
  }, [tourId, game, reload]);
  const visible = teams.filter((team) => allTeams || team.registered);
  const chosen = visible.filter((team) => selected.includes(team.id));
  const draw = () => {
    try {
      const next = drawGroups(chosen.map((team) => team.name.trim()));
      if (groups.some((group) => group.teams.length) && !window.confirm('Заменить состав групп случайной жеребьёвкой? При изменении пар прежние результаты потребуют проверки.')) return;
      onDraw(next);
      setError('');
    } catch (err) { setError(err.message); }
  };
  return <div className="rounded-xl border border-line p-4 mb-4">
    <h3 className="font-bold mb-2">Случайная жеребьёвка</h3>
    <p className="text-fg-muted text-sm mb-3">Выберите от 16 до 20 команд. Только выбранные команды будут перемешаны и распределены поровну по четырём группам. Публикация — после сохранения турнира.</p>
    <label className="flex gap-2 items-center mb-3"><input type="checkbox" checked={allTeams} onChange={(event) => setAllTeams(event.target.checked)} />Показать все команды дисциплины</label>
    <button type="button" className="fed-btn-ghost px-3 py-2 mb-3" disabled={loading} onClick={() => setReload(reload + 1)}>Обновить список</button>
    {loading ? <p role="status">Загрузка команд…</p> : <>
      <div className="flex gap-3 mb-3">
        <button type="button" className="fed-btn-ghost px-3 py-2" onClick={() => setSelected(visible.map((team) => team.id))}>Выбрать все</button>
        <button type="button" className="fed-btn-ghost px-3 py-2" onClick={() => setSelected([])}>Снять выбор</button>
      </div>
      <div className="grid gap-2 md:grid-cols-2 mb-3" style={{ maxHeight: 320, overflowY: 'auto' }}>
        {visible.map((team) => <label key={team.id} className="flex items-center gap-2 rounded-lg border border-line p-2">
          <input type="checkbox" checked={selected.includes(team.id)} onChange={(event) => setSelected(event.target.checked ? [...selected, team.id] : selected.filter((id) => id !== team.id))} />
          {team.name}{team.registered && <span className="text-fg-muted text-xs">· заявлена</span>}
        </label>)}
      </div>
      {!visible.length && <p className="text-fg-muted mb-3">Команд в списке нет.</p>}
    </>}
    {error && <p role="alert" className="text-gold mb-3">{error}</p>}
    <button type="button" className="fed-btn-primary px-4 py-2" disabled={loading || chosen.length < 16 || chosen.length > 20} onClick={draw}>Перемешать выбранные и составить группы ({chosen.length})</button>
  </div>;
}
